@if (show) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <div class="d-flex justify-content-end">
        <button class="btn-close" id="btnOk" (click)="cancelar()" aria-label="Close"></button>
      </div>
      <h1 class="titulo-alert-descarte">Descartar alterações</h1>
      <p class="subtitulo-alert-descarte">Atenção: ao prosseguir, todas as alterações feitas até o momento  serão descartadas.</p>
      <div class="d-flex justify-content-center">
        <button class="botao-descarte bg-descarte-cancela" (click)="descartar()">DESCARTAR ALTERAÇÕES</button>
        <button class="botao-descarte bg-descarte-confirma" (click)="cancelar()">VOLTAR E CONCLUIR</button>
      </div>
    </div>
  </div>
}
